// -------------------------------------------------------------------------------------------
// entraIdClientId: "cb18d782-1469-47bc-b543-a4afe2dd3386",
// entraIdAuthority: "https://login.microsoftonline.com/96cb90b2-e839-4620-9c96-54b5ab54693d",
// entraIdRedirectUri: "https://auditplanweb-hml.aparholdings.com.br/",
//
// APAR HOMOLOG SETTINGS
// -------------------------------------------------------------------------------------------
export default
{
  entraIdCacheLocation: "localStorage",
  entraIdStoreAuthStateInCookie: false,
  authConfigRoute: "api/Authentication/Config",
  backendUrl: "https://fn2jtunb2yircojtnkr3v4cviq0hihyr.lambda-url.us-east-1.on.aws/"
}


// LOCAL SETTINGS
// export default
// {
//   entraIdCacheLocation: "localStorage",
//   entraIdStoreAuthStateInCookie: false,
//   authConfigRoute: "api/Authentication/Config",
//   backendUrl: "https://localhost:7063/"
// }

// WHYBE SETTINGS
// export default
// {
//   entraIdCacheLocation: "localStorage",
//   entraIdStoreAuthStateInCookie: false,
//   authConfigRoute: "api/Authentication/Config",
//   backendUrl: "https://gnbdurktitf422vjxriipfotpm0lwkic.lambda-url.us-east-1.on.aws/"
// }

